import React, { Component } from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux';

import { PrevArrow, NextArrow } from './CarouselArrows';
import { parseFactValue } from '../../Utils/otherUtils';
import mapPinLocation from '../../Images/Icons/icon_map_pin_your_location.svg';

function factsMap(facts, titles) {
  // div to protect from frame-collapse when no data has been loaded yet.
  if (!facts.length) return (<div className="fact-box loading" />);

  return facts.map((fact) => {
    const factValue = parseFactValue(fact.type, fact.value);
    return (
      <div className="fact-box" key={fact.type}>
        <div className="content-wrapper">
          <div className="title">
            <div className="inner">
              <p>
                {titles[fact.type]}
                {fact.type === 'commuteDestination' &&
                <img className="pin" src={mapPinLocation} alt="map-pin" />}
              </p>
            </div>
          </div>
          <p className="metric-value">{factValue.value && factValue.value !== 0 ? factValue.value : '-'}</p>
          <p className="metric-type">{factValue.metric}</p>
        </div>
      </div>
    );
  });
}

class FactCarousel extends Component {
  render() {
    const {
      Language: {
        text: {
          common: {
            next, prev,
          },
        },
      },
    } = this.props;
    const settings = {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: false,
      nextArrow: <NextArrow label={next} />,
      prevArrow: <PrevArrow label={prev} />,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        }],
    };
    const {
      facts,
      titles,
    } = this.props;
    return (
      <div className="facts-wrapper">
        <div className="fact-box-wrapper">
          <Slider {...settings}>{factsMap(facts, titles)}</Slider>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  Language: state.Language,
});

export default connect(mapStateToProps)(FactCarousel);



// WEBPACK FOOTER //
// ./src/Components/Carousel/FactCarousel.js